/* eslint-disable */
import * as React from "react";

import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { BusinessUnitControl } from "../controls/BusinessUnitControl";

import { useFavourite } from "./useFavourite";
export default function () {
  useFavourite();
  return (
    <ReportToolbarGroup vertical>
      <BusinessUnitControl />
    </ReportToolbarGroup>
  );
}
